import React from 'react';
import { Row, Col } from 'antd';

interface ToolbarProps {
  left: React.ReactNode;
  right: React.ReactNode;
  className?: string;
}

const ToolbarLayout: React.FC<ToolbarProps> = ({ left, right, className = '' }) => {
  return (
    <div className={`bg-white px-6 py-[9px]  ${className}`}>
      <Row justify='space-between' align='middle' className='min-h-10 flex-wrap gap-y-4'>
        <Col>{left}</Col>
        <Col>{right}</Col>
      </Row>
    </div>
  );
};

export default ToolbarLayout;
